$(document).ready(() => {
  $(window).on('action:ajaxify.end', () => {
    // console.log(info);
    const $button = $('#leech-button');
    const $dialog = $('#leech-dialog');
    $button.click(() => {
      $dialog.modal();
    });

    $('#leech-send').click(() => {
      const url = $('#leech-url').val();
      const template = ajaxify.data.template.name;
      const reqData = { url };

      if (template === 'category') {
        reqData.cid = ajaxify.data.cid;
      } else if (template === 'topic') {
        reqData.tid = ajaxify.data.tid;
      }

      // console.log(url);
      $.post('/api/leech-tool', reqData, (resData) => {
        let dest;
        if (resData.tid) {
          dest = `topic/${resData.tid}`;
        } else if (resData.pid) {
          dest = `post/${resData.pid}`;
        } else {
          app.alert({
            alert_id: 'leech-failed',
            type: 'danger',
            title: 'Failed',
            message: 'Post not found',
          });
          return;
        }
        $dialog.one('hidden.bs.modal', (/* err */) => {
          ajaxify.go(dest);
        });
        $dialog.modal('hide');
      });
    });
  });
});
